<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="8">
          <h3>{{ $route.name }}</h3>
        </b-col>
        <b-col md="6">
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form v-on:submit.prevent="doFilter">
            <b-row class="mb-3 mt-3">
              <b-col md="4 mb-3" class="d-flex">
                <b-form-input
                  v-model="tableFilter.worksheetId"
                  customQueryParamName="search"
                  placeholder="Worksheet ID"
                  class="font-weight-bold"
                  style="font-size: 20px; color: #3d3d3d"
                />
              </b-col>
              <b-col md="3 mb-3" class="d-flex">
                <b-form-select
                  v-model="tableFilter.worksheetType"
                  :options="worksheetTypeData"
                />
              </b-col>

              <b-col md="3 mb-3" class="d-flex">
                <b-form-select
                  v-model="tableFilter.statusWork"
                  placeholder="Status"
                  :options="dataStatus"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4 mb-3" class="d-flex">
                <b-form-input
                  v-model="tableFilter.searchCustomer"
                  customQueryParamName="search"
                  placeholder="Customer Search"
                  class="font-weight-bold"
                  style="font-size: 20px; color: #3d3d3d"
                />
              </b-col>
              <b-col md="4 mb-3" class="d-flex">
                <b-form-input
                  v-model="tableFilter.employee"
                  customQueryParamName="search"
                  placeholder="Employee Search"
                  class="font-weight-bold"
                  style="font-size: 20px; color: #3d3d3d"
                />
              </b-col>
              <b-col md="3">
                <button type="submit" class="ml-2 btn btn-primary" id="btn-search">
                  <font-awesome-icon icon="search" />Filter
                </button>

                <button
                  @click="clearFilter()"
                  class="ml-0 btn btn-outline-danger ml-2"
                  id="btn-search"
                >
                  clear
                </button>
              </b-col>
              <!-- <b-col md="3"> </b-col> -->
            </b-row>
          </b-form>
        </b-col>
      </b-row>
      <paginated-table
        ref="dataTable"
        :can-delete="false"
        :can-approve="false"
        :can-show="true"
        :can-paid="false"
        :data-url="apiUrl.worksheet"
        :data-key="dataKey"
        :data-columns="columns"
        class="mb-4"
        :data-params="[
          'search_name',
          'worksheet_id',
          'search_customer',
          'worksheet_type',
          'status',
        ]"
      >
      </paginated-table>
    </b-card>
  </div>
</template>

<script>
import PaginatedTable from '../../components/PaginatedTable.vue';
export default {
  name: 'worksheet',
  components: { PaginatedTable },
  data() {
    return {
      dataKey: 'worksheet',
      apiUrl: {
        worksheet: window.AppConfig.apiUrl + 'worksheet',
      },
      worksheetTypeData: [{
        text: 'Select worksheet',
        value: null
      }],
      dataStatus: [
        {
          value: null,
          text: 'Select Status',
        },
        {
          text: 'Created',
          value: 'Created',
        },
        {
          text: 'In Progress',
          value: 'In Progress',
        },
        {
          text: 'Solved',
          value: 'Solved',
        },
        {
          text: 'Done',
          value: 'Done',
        },
      ],
      columns: [
        {
          key: 'worksheetId',
          label: 'ID',
          sortable: true,
        },
        {
          key: 'createdBy.firstName',
          label: 'Employee',
          sortable: true,
        },
        {
          key: 'customer.name',
          label: 'Customer',
          sortable: true,
        },
        {
          key: 'worksheetType.name',
          label: 'Type',
          sortable: true,
        },
        {
          key: 'createdAt',
          label: 'Created Date',
          sortable: true,
        },
        {
          key: 'worksheetFinishDate',
          label: 'Finished Date',
          sortable: true,
        },
        {
          key: 'statusWork',
          label: 'Status',
        },
        {
          key: 'actionWorksheet',
          label: '',
        },
      ],
      tableFilter: {
        worksheetId: this.$route.params.worksheet_id,
        // worksheetType: this.$route.params.worksheet_type,
        searchCustomer: this.$route.params.search_customer,
        employee: this.$route.params.search_name,
        // statusWork: this.$route.params.status,
        statusWork: null,
        worksheetType: null
      },
    };
  },

  mounted() {
    this.getWorksheetType();
  },
  methods: {
    getWorksheetType() {
      this.$http.get(window.AppConfig.apiUrl + 'worksheet-type').then((response) => {
        this.worksheetTypeData = [{text: 'Select Worksheet Type', value: null}];
        response.data._embedded.worksheet_type.forEach((data) => {
          this.worksheetTypeData.push({
            text: data.name,
            value: data.name,
          });
        });
      });
    },
    doFilter() {
      // eslint-disable-next-line no-self-assign
      (this.tableFilter.worksheet_id = this.tableFilter.worksheetId),
        (this.tableFilter.worksheet_type = this.tableFilter.worksheetType),
        (this.tableFilter.search_customer = this.tableFilter.searchCustomer),
        (this.tableFilter.search_name = this.tableFilter.employee),
        (this.tableFilter.status = this.tableFilter.statusWork),
        this.$refs.dataTable.doFilter(this.tableFilter);
    },
    clearFilter() {
      this.tableFilter.worksheetType = null;
      this.tableFilter.worksheetId = null;
      this.tableFilter.employee = null;
      this.tableFilter.searchCustomer = null;
      this.tableFilter.statusWork = null;
    },
  },
};
</script>
